<template>

    <button class="inline-block w-2/4 button-blue-light text-white rounded pk-bg-blue-100"
            @click="$emit('submit')">{{ $t('text.further_information')}}
    </button>

</template>

<script>
    export default {
        name: "MissionInformationRequestButton"
    }
</script>

<style scoped>
    .pk-bg-blue-100 {
        background-color: #5bc0de;
    }
</style>